import React from 'react'

// material ui
import Box from '@mui/material/Box'

// atomic components/containers
import Loading from 'components/atoms/Loading'
import Typography from '@mui/material/Typography'
import ErrorMessage from 'components/shared/ErrorMessage'
import AccountButton from 'components/atoms/AccountButton'

// components specific to registration
import RegistrationStep from 'components/register/shared/RegistrationStep'

// components shared with account manager
import Campers from 'components/account/Plans/Campers'
import Parents from 'components/account/Overview/Parents'
import EmergencyContacts from 'components/account/Overview/EmergencyContacts'
import PickupPeople from 'components/account/Overview/PickupPeople'
import SuccessMessage from 'components/shared/ErrorMessage/UI'

// containers shared with account manager
import Waiver from 'components/shared/Waiver'

const Complete = props => {
  const {
    account, // via withQuery
    loading, // via withQuery
    enableCovidRequirements // via withQuery
  } = props

  const { preferences, waivers } = account || {}
  const { onlineOnly = true } = preferences || {}

  return (
    <RegistrationStep>
      <Box mt={2}>
        <ErrorMessage />
        {account && (
          <SuccessMessage variant='success' message='Registration Complete'>
            <Box my={2}>
              <Typography gutterBottom variant='body1'>
                A confirmation email has been sent to {account.email}.
              </Typography>
            </Box>
          </SuccessMessage>
        )}
      </Box>
      {!account || loading ? (
        <Loading />
      ) : (
        <>
          <Box align='center'>
            <AccountButton
              href='/account'
              variant='contained'
              color='secondary'
              my={4}
            >
              Go to My Account
            </AccountButton>
          </Box>

          <Campers
            title='Registered Campers'
            account={account}
            enableCovidRequirements={enableCovidRequirements}
          />

          <Parents title='Parents / Guardians' account={account} />
          {!onlineOnly && (
            <>
              <EmergencyContacts title='Emergency Contacts' account={account} />
              <PickupPeople title='Pick-up People' account={account} />
            </>
          )}
          <Box my={4}>
            {waivers.map(waiver => (
              <Waiver key={waiver.id} waiver={waiver} />
            ))}
          </Box>

          <Box align='center'>
            <AccountButton
              href='/account'
              variant='contained'
              color='secondary'
            >
              Go to My Account
            </AccountButton>
          </Box>
        </>
      )}
    </RegistrationStep>
  )
}

export default Complete
